export const generateWhatsAppLink = ({ text = '', phone = '' }) => {
  if (!phone) return null;

  let cleanPhone = phone.replace(/[^\d]/g, '');

  cleanPhone = cleanPhone.replace(/^0+/, '');

  const encodedText = encodeURIComponent(text);

  return `https://wa.me/${cleanPhone}?text=${encodedText}`;
};
